import { create } from 'zustand';
const THEME_STORAGE_KEY = 'snapv_theme';
const getStoredTheme = () => {
    if (typeof window === 'undefined') {
        return 'dark';
    }
    const stored = window.localStorage.getItem(THEME_STORAGE_KEY);
    return stored === 'dark' ? 'dark' : 'dark';
};
export const useThemeStore = create((set, get) => ({
    theme: 'dark',
    hydrated: false,
    setTheme: (theme) => {
        if (typeof window !== 'undefined') {
            window.localStorage.setItem(THEME_STORAGE_KEY, 'dark');
            document.documentElement.dataset.theme = 'dark';
            document.body.dataset.theme = 'dark';
        }
        set({ theme: 'dark' });
    },
    toggleTheme: () => {
        get().setTheme('dark');
    },
    hydrateTheme: () => {
        if (typeof window !== 'undefined') {
            document.documentElement.dataset.theme = 'dark';
            document.body.dataset.theme = 'dark';
            window.localStorage.setItem(THEME_STORAGE_KEY, 'dark');
        }
        set({ theme: 'dark', hydrated: true });
    },
}));
